export default __webpack_public_path__ + "static/media/castlecrypto_image.7da88652.png";